import { Navbar, Nav, NavDropdown, MenuItem, Button } from "react-bootstrap"
import React from "react"
import { Link } from "react-router-dom"
import { LinkContainer } from "react-router-bootstrap"

export default function({
	uid,
	email,
	plan,
	planExpiresAt,
	onSignIn,
	onSignOut,
}) {
	const planName = getPlanName(plan)
	return (
		<Navbar fluid collapseOnSelect>
			<Navbar.Header>
				<Navbar.Brand>
					<Link to="/">
						Crypto Portfolio Tracker <b>{planName}</b>
					</Link>
				</Navbar.Brand>
				<Navbar.Toggle />
			</Navbar.Header>
			<Navbar.Collapse>
				<div className="navbar-right">
					<Button
						bsSize="xsmall"
						href="https://twitter.com/crypto_port"
						rel="noopener noreferrer"
						target="_blank"
						className="navbar-btn"
					>
						Follow @crypto_port
					</Button>
					{uid
						? email
							? UserNav({ email, planName, planExpiresAt, onSignOut })
							: AnonymousUserNav({ onSignIn, onSignOut })
						: SignedOutNav()}
				</div>
			</Navbar.Collapse>
		</Navbar>
	)
}

function UserNav({ email, planName, planExpiresAt, onSignOut }) {
	return (
		<Nav pullRight>
			<NavDropdown eventKey="1" title={email} id="user-dropdown">
				<MenuItem eventKey="1.1" disabled>
					Plan: {planName ? planName : "Free"}
				</MenuItem>
				{planExpiresAt ? (
					<MenuItem eventKey="1.1" disabled>
						Active To: {new Date(planExpiresAt).toLocaleDateString()}
					</MenuItem>
				) : null}
				<MenuItem divider />
				<LinkContainer to="/settings">
					<MenuItem eventKey="1.3">Settings</MenuItem>
				</LinkContainer>
				<MenuItem eventKey="1.4" onClick={onSignOut}>
					Sign out
				</MenuItem>
			</NavDropdown>
		</Nav>
	)
}

function SignedOutNav() {
	return (
		<Navbar.Form pullRight>
			<LinkContainer to="/sign-in">
				<Button bsStyle="primary">Sign in</Button>
			</LinkContainer>
		</Navbar.Form>
	)
}

function AnonymousUserNav({ onSignIn, onSignOut }) {
	return (
		<Nav pullRight>
			<NavDropdown eventKey="1" title={"Anonymous User"} id="user-dropdown">
				<MenuItem eventKey="1.1" onClick={onSignIn}>
					<b>Create user account</b>
				</MenuItem>
				<MenuItem eventKey="1.2" onClick={onSignOut}>
					Sign out / delete data
				</MenuItem>
			</NavDropdown>
		</Nav>
	)
}

const planNames = {
	classic: "Classic",
	pro: "Pro",
	ultimate: "Ultimate",
	standard: "Standard",
}

function getPlanName(id) {
	if (id === null) {
		return null
	}
	const name = planNames[id]
	if (name === undefined) {
		return null
	}
	return name
}



// WEBPACK FOOTER //
// ./src/Navbar.js